export default class Pagination {
  paginateCallback: Function;

  currentPage: number;

  constructor(paginateCallback: Function, defaultPage: number = 1) {
    this.paginateCallback = paginateCallback;
    this.currentPage = defaultPage;
  }

  fetch(page: number) {
    this.currentPage = page;
    return this.paginateCallback(page);
  }

  fetchFirst() {
    return this.fetch(1);
  }

  fetchPrevious() {
    return this.fetch(this.currentPage - 1);
  }

  fetchNext() {
    return this.fetch(this.currentPage + 1);
  }
}
